var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M128,151.8c20.3,0,36-8.5,47.1-25.5c0-7-5.4-12.8-16.4-17.5c-10.9-4.6-21.1-6.9-30.8-6.9c-9.6,0-19.8,2.3-30.8,6.9c-10.9,4.6-16.4,10.4-16.4,17.5C92,143.3,107.7,151.8,128,151.8z M128,33.3c-6.3,0-11.8,2.4-16.6,7.2c-4.8,4.8-7.2,10.3-7.2,16.6c0,6.6,2.4,12.3,7.2,16.9c4.8,4.6,10.3,6.9,16.6,6.9c6.3,0,11.8-2.3,16.6-6.9c4.8-4.6,7.2-10.3,7.2-16.9c0-6.3-2.4-11.8-7.2-16.6C139.8,35.7,134.3,33.3,128,33.3z M128,10c22.9,0,42.4,8,58.4,24.1c16.1,16.1,24.1,35.5,24.1,58.4c0,11.4-2.9,24.6-8.6,39.3c-5.7,14.8-12.6,28.6-20.8,41.5c-8.1,12.9-16.2,25-24.1,36.3s-14.7,20.2-20.2,26.9L128,246c-2.2-2.6-5.2-6-8.9-10.3c-3.7-4.2-10.3-12.7-19.9-25.5c-9.6-12.7-18-25.1-25.2-37.1c-7.2-12-13.8-25.6-19.7-40.7c-5.9-15.1-8.9-28.4-8.9-39.9c0-22.9,8-42.4,24.1-58.4S105.1,10,128,10z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonRed);
export default __webpack_public_path__ + "static/media/personRed.77e738ee9e452d018f48def05bccb60a.svg";
export { ForwardRef as ReactComponent };